// shared/ui/Loader.tsx
import React from 'react';
import './Loader.scss';

export const Loader: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <span
    className="rt-loader"
    role="status"
    aria-label="Loading"
    style={{ width: size, height: size }}
  />
);
